import React from 'react'
// reactivate cookie consent if leaving ezoic
// import CookieConsent from 'react-cookie-consent' //uninstalled
// import {CookieNotice} from "gatsby-cookie-notice"; //uninstalled
// import { useLocation } from "@reach/router" // this helps tracking the location
// import { initializeAndTrack } from 'gatsby-plugin-gdpr-cookies'

import "@fontsource/oswald/700.css"
import "@fontsource/satisfy"
import "@fontsource/la-belle-aurore"
import "@fontsource/open-sans"
import "@fontsource/open-sans/300.css"
import "@fontsource/open-sans/600.css"
import "@fontsource/fira-sans/200-italic.css"
import "@fontsource/fira-sans/200.css"
import "@fontsource/fira-sans/300-italic.css"
import "@fontsource/fira-sans/300.css"
import "@fontsource/fira-sans/400-italic.css"
import "@fontsource/fira-sans/400.css"
import "@fontsource/fira-sans/600.css"
import "@fontsource/poppins/300.css"
import "@fontsource/poppins/400.css"

import Header from './header'
import Footer from './footer'
import '../styles/index.scss'
import * as layoutStyles from './layout.module.scss'
import { Helmet } from "react-helmet"


const Layout = ({ children, location }) => {
  return(
    <div className="wrapper">
      
      {/* <CookieConsent location="bottom" buttonText="Got it.">This website uses cookies to enhance the user experience.</CookieConsent> */}
      {/* <div className={layoutStyles.cookieBanner}>
        <CookieNotice 
          personalizeButtonClasses={layoutStyles.cookieButton}
          acceptButtonClasses={layoutStyles.acceptCookieButton}
          declineButtonClasses={layoutStyles.cookieButton}
          backgroundClasses={layoutStyles.cookieBackground}
          wrapperClasses={layoutStyles.wrapperClasses}
          buttonWrapperClasses={layoutStyles.buttonWrapperClasses}
          personalizeValidationClasses={layoutStyles.acceptCookieButton}
          cookieListClasses={layoutStyles.cookieList}
          personalizeButtonText={"Choose cookies"}
          cookies={[
                  {name: 'necessary', editable: false, default: true, title: 'Necessary', text: 'Necessary cookies are required for the proper functioning of the site.' },
                  {name: 'gatsby-gdpr-google-tagmanager', editable: true, default: true, title: 'Statistics', text: 'We use these cookies to determine how many people have visited our website and which content is most popular.' },
                  {name: 'ezoic-ads', editable: true, default: true, title: 'Marketing', text: 'We use these cookies to customize your ad experience.'}
            ]}>
            <h4>This website uses cookies.</h4>
            <p>Steph Sunshine uses cookies to make the site function and to see how users interact with it.</p>
        </CookieNotice>
      </div> */}
     <Helmet>
      {/* Mediavine Journey Script */}
     <script type="text/javascript" async="async" data-noptimize="1" data-cfasync="false" src="//scripts.scriptwrapper.com/tags/6ca38f2c-6a22-458b-9508-dcc93b63e6d8.js"></script>
      {/* end Mediavine Journey script */}

{/* MV Script */}

<script type="text/javascript" async="async" data-noptimize="1" data-cfasync="false" src="scripts.mediavine.com/tags/6ca38f2c-6a22-458b-9508-dcc93b63e6d8.js"></script>

{/* end MV script */}
{/* force secure ads */}
​<meta http-equiv="Content-Security-Policy" content="block-all-mixed-content" />
{/* end force secure ads */}

        <script crossorigin src="https://apis.google.com/js/platform.js"></script>
        {/* Microsoft Clarity */}
        <script type="text/javascript">
          {`
    (function(c,l,a,r,i,t,y){
        c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
        t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
        y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
    })(window, document, "clarity", "script", "k5n9mqqxl6");
    `}
</script>
{/* Grow by Mediavine Script */}
  <script data-grow-initializer="">
    {`
    !(function(){window.growMe||((window.growMe=function(e){window.growMe._.push(e);}),(window.growMe._=[]));var e=document.createElement("script");(e.type="text/javascript"),(e.src="https://faves.grow.me/main.js"),(e.defer=!0),e.setAttribute("data-grow-faves-site-id","U2l0ZTo2Y2EzOGYyYy02YTIyLTQ1OGItOTUwOC1kY2M5M2I2M2U2ZDg=");var t=document.getElementsByTagName("script")[0];t.parentNode.insertBefore(e,t);})();
    `}
  </script>
     </Helmet>
      <Header location={location} />
      <div className="layout-container" id="container">
        <div className={layoutStyles.content}>
          {children}
        </div>
      </div>
      <Footer />
    </div>
)
}

export default Layout
